export default __webpack_public_path__ + "static/media/mlh-trust-badge-2022-white.f6632575.svg";